import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Footer() {

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const whatsappNumber = "919998488480"; // Replace with your WhatsApp number in international format
  const whatsappMessage = "Hello! I would like to inquire about your services.";


  return (
    <footer className="bg-[#f8ede3] text-white pt-16 bg-cover bg-center bg-no-repeat relative"
    >

        <a
  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
  target="_blank"
  rel="noopener noreferrer"
  className="absolute bottom-6 z-[999] right-2 w-fit  bg-green-500 text-white py-2 p-3 rounded-lg hover:bg-green-600 transition"
>
  <i className="fa-brands fa-whatsapp text-xl"></i>
</a>

      {/* OVERLAY */}
      {/* <div className="absolute inset-0 bg-black/80 backdrop-blur-sm"></div> */}

      {/* ===================== TOP GRID ===================== */}
      <div className=" relative z-10 max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">

        {/* 1. LOGO + DESCRIPTION */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}>
          {/* LOGO CENTER */}
          <Link to="/" className="text-center">
            <img src="/images/logo/apnawebxlogo.png" loading="lazy" alt="ApnaWebx" className="h-18 " />
          </Link>
          <p className="text-[#855109] text-sm font-vollkorn leading-relaxed">
            ApnaWebX delivers modern websites, mobile apps and  WhatsApp Bulk Marketing services.
          </p>
        </motion.div>

        {/* 2. SERVICES LIST */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h3 className="text-xl font-montserrat font-extrabold mb-4 text-[#855109]">
            Our Services
          </h3>

          <ul className="space-y-2 text-[#855109] text-lg">

            <motion.li whileHover={{ x: 6 }}>
              <Link to="/services">
                <FontAwesomeIcon icon={faChevronRight} className="mr-2" />
                Website Development
              </Link>
            </motion.li>

            <motion.li whileHover={{ x: 6 }}>
              <Link to="/services">
                <FontAwesomeIcon icon={faChevronRight} className="mr-2" />
                App Development
              </Link>
            </motion.li>

            <motion.li whileHover={{ x: 6 }}>
              <Link to="/services">
                <FontAwesomeIcon icon={faChevronRight} className="mr-2" />
                WhatsApp Bulk Messaging
              </Link>
            </motion.li>

            <motion.li whileHover={{ x: 6 }}>
              <Link to="/services">
                <FontAwesomeIcon icon={faChevronRight} className="mr-2" />
                Digital Marketing
              </Link>
            </motion.li>

            <motion.li whileHover={{ x: 6 }}>
              <Link to="/services">
                <FontAwesomeIcon icon={faChevronRight} className="mr-2" />
                SEO Services
              </Link>
            </motion.li>

            <motion.li whileHover={{ x: 6 }}>
              <Link to="/services">
                <FontAwesomeIcon icon={faChevronRight} className="mr-2" />
                Social Media Management
              </Link>
            </motion.li>

          </ul>
        </motion.div>


        {/* 3. QUICK LINKS */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h3 className="text-xl font-montserrat font-extrabold mb-4 text-[#855109]">
            Quick Links
          </h3>

          <ul className="space-y-2 text-[#855109] text-lg">
            {[
              { name: "Home", path: "/" },
              { name: "About Us", path: "/about" },
              { name: "Services", path: "/services" },
              { name: "Portfolio", path: "/portfolio" },
              { name: "Contact Us", path: "/contact" },
            ].map((link, index) => (
              <motion.li key={index} whileHover={{ x: 6 }}>
                <Link
                  to={link.path}
                  onClick={scrollTop}
                  className="flex items-center gap-2 hover:text-[#6e4208] transition"
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                  {link.name}
                </Link>
              </motion.li>
            ))}
          </ul>
        </motion.div>


        {/* 4. CONTACT + SOCIAL */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}>
          <h3 className="text-xl font-montserrat font-extrabold mb-4 text-[#855109]">
            Contact Us
          </h3>

          {/* Buttons */}
          <div className="space-y-0">
            <a
              href="tel:+91 99984 88480"
              className="flex items-center gap-3 bg-white/10 border border-white/20 px-4 py-2 
              rounded-lg hover:bg-[#855109]/20 transition text-[#855109]"
            >
              <FontAwesomeIcon icon={faPhone} />
              +91 99984 88480
            </a>

            <a
              href="mailto:support@apnawebx.com"
              className="flex items-center gap-3 bg-white/10 border border-white/20 px-4 py-2 
              rounded-lg hover:bg-[#855109]/20 transition text-[#855109]"
            >
              <FontAwesomeIcon icon={faEnvelope} />
              support@apnawebx.com
            </a>

            <a href="https://maps.app.goo.gl/Wi5AzdjPKAa4UGW8A" target="_blank" rel="noreferrer" className="flex items-center gap-3 bg-white/10 border border-white/20 px-4 py-2 
            rounded-lg hover:bg-[#855109]/20 transition text-[#855109]">
              <FontAwesomeIcon icon={faLocationDot} />
              Ahmedabad, Gujarat
            </a>
          </div>

          {/* Social Media Icons */}
          <div className="flex gap-5 text-xl mt-5 text-[#855109]">

            <motion.div whileHover={{ x: 6 }}>
              <a
                href="https://www.instagram.com/apnawebx/"
                target="_blank"
                rel="noreferrer"
                className="text-[#855109] hover:text-[#855109] transition"
                aria-label="Visit ApnaWebX on Instagram"
              >
                <FontAwesomeIcon className="icon" icon={faInstagram} />
              </a>
            </motion.div>

            <motion.div whileHover={{ x: 6 }}>
              <a
                href="https://www.facebook.com/apnawebx"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#855109] text-[#855109] transition"
                aria-label="Visit ApnaWebX on Facebook"
              >
                <FontAwesomeIcon className="icon" icon={faFacebook} />
              </a>
            </motion.div>

            <motion.div whileHover={{ x: 6 }}>
              <a
                href="https://www.linkedin.com/company/107929005/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#855109] text-[#855109] transition"
                aria-label="Visit ApnaWebX on LinkedIn"
              >
                <FontAwesomeIcon className="icon" icon={faLinkedin} />
              </a>
            </motion.div>

            <motion.div whileHover={{ x: 6 }}>
              <a
                href="https://x.com/apnawebx"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#855109] text-[#855109] transition"
                aria-label="Visit ApnaWebX on X (Twitter)"
              >
                <FontAwesomeIcon className="icon" icon={faTwitter} />
              </a>
            </motion.div>

          </div>

        </motion.div>
      </div>

      {/* ===================== IMAGE STRIP ===================== */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}>
        <div className="relative z-10 max-w-7xl mx-auto px-6 mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          <motion.div whileHover={{ y: 6 }}> <img src="/images/home/service-bg.jpg" className="h-32 w-full object-cover rounded-lg" alt="ApnaWebX" loading="lazy" /></motion.div>
          <motion.div whileHover={{ y: 6 }}> <img src="/images/home/hero-home.jpg" className="h-32 w-full object-cover rounded-lg" alt="ApnaWebX" loading="lazy" /></motion.div>
          <motion.div whileHover={{ y: 6 }}>  <img src="/images/home/why-bg.jpg" className="h-32 w-full object-cover rounded-lg" alt="ApnaWebX" loading="lazy" /></motion.div>
          <motion.div whileHover={{ y: 6 }}> <img src="/images/home/about-sec.jpg" className="h-32 w-full object-cover rounded-lg" alt="ApnaWebX" loading="lazy" /></motion.div>
        </div>
      </motion.div>
      {/* ===================== COPYRIGHT BAR ===================== */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}>
        <div className="relative z-10 text-center py-6 mt-10 border-t border-[#855109]/10  
        text-sm font-vollkorn text-[#855109]">
          © {new Date().getFullYear()} <strong>ApnaWebX</strong> . All Rights Reserved.
        </div>
      </motion.div>
    </footer>
  );
}
